// Stable per-browser id used to prove ownership of a feedback post (see
// core/feedback.js and server/feedback.js) - deliberately its own id, not a
// reuse of core/metrics.js's client id. That file already keeps its id
// separate from sync.js's for the same reason in the other direction:
// mixing concerns makes each one wrong for what the other needs. Here,
// flipping the metrics opt-out (?notrack=1) must not affect who owns a
// feedback post, and vice versa.
import { safeGet, safeSet } from './local-storage.js';

const DEVICE_ID_STORAGE_KEY = 'halveren-device-id';

function loadOrCreateDeviceId() {
    const existing = safeGet(DEVICE_ID_STORAGE_KEY);
    if (existing) return existing;
    const id = `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
    safeSet(DEVICE_ID_STORAGE_KEY, id);
    return id;
}

// Read once per page load, same reasoning as core/metrics.js's clientId -
// stays stable for the page's lifetime even where storage is unavailable
// (safeSet is then a no-op and a fresh id would otherwise be minted per call).
const deviceId = loadOrCreateDeviceId();

export function getDeviceId() {
    return deviceId;
}
